import React, { createContext, useState } from "react";

export const PersonaContext = createContext();

export const PersonaProvider = ({ children }) => {
  const [personaDetails, setPersonaDetails] = useState([]);

  return (
    <PersonaContext.Provider value={{ personaDetails, setPersonaDetails }}>
      {children}
    </PersonaContext.Provider>
  );
};